import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";

export const SolutionsText = styled.div`
    margin-bottom: 4px;
    height: 24px;
    display: flex;
    align-items: center;
    margin-left: 8px;
    ${setFontVariant("primaryItem", colorsPalettes.carbon[500])};
`;

export const SolutionGroupWrapper = styled.div<{
    marginBottom?: number;
}>`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-bottom: ${({ marginBottom }) => marginBottom ?? 0}px;
    gap: 2px;
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;
